import React, { useState } from 'react';
import { FaStar, FaQuoteLeft, FaFilter } from 'react-icons/fa';
import { Link } from 'react-scroll';

const Portfolio = () => {
    const [activeFilter, setActiveFilter] = useState('ALL');

    const testimonials = [
        {
            id: 1,
            name: "Priya Sharma",
            category: "LOVE",
            image: "IMG-20250831-WA0017.jpg",
            rating: 5,
            text: "Dhananjay Pandey's guidance completely transformed my understanding of relationships. His insights were incredibly accurate and helped me find my soulmate.",
            service: "Love Compatibility Reading"
        },
        {
            id: 2,
            name: "Rajesh Kumar",
            category: "CAREER",
            image: "IMG-20250831-WA0022.jpg",
            rating: 5,
            text: "The career guidance I received was spot-on. Within months of following the remedies suggested, I got the promotion I was waiting for.",
            service: "Career Astrology"
        },
        {
            id: 3,
            name: "Anita Verma",
            category: "SPIRITUAL",
            image: "IMG-20250831-WA0028.jpg",
            rating: 5,
            text: "The spiritual insights and remedies provided have brought immense peace and clarity to my life. Highly recommended!",
            service: "Spiritual Guidance"
        },
        {
            id: 4,
            name: "Vikram Singh",
            category: "BUSINESS",
            image: "IMG-20250831-WA0034.jpg",
            rating: 5,
            text: "The business timing predictions were incredibly accurate. Started my venture at the suggested time and it's been profitable since day one.",
            service: "Business Astrology"
        },
        {
            id: 5,
            name: "Meera Patel",
            category: "HEALTH",
            image: "IMG-20250831-WA0038.jpg",
            rating: 5,
            text: "The health predictions and remedial measures helped me overcome a long-standing health issue. Forever grateful!",
            service: "Health Astrology"
        },
        {
            id: 6,
            name: "Amit Gupta",
            category: "MARRIAGE",
            image: "IMG-20250831-WA0036.jpg",
            rating: 5,
            text: "The marriage timing prediction was perfect. Got married exactly when predicted and it's been a blissful journey.",
            service: "Marriage Timing"
        }
    ];

    const filters = ['ALL', 'LOVE', 'CAREER', 'SPIRITUAL', 'BUSINESS', 'HEALTH', 'MARRIAGE'];

    const filteredTestimonials = activeFilter === 'ALL'
        ? testimonials
        : testimonials.filter(testimonial => testimonial.category === activeFilter);

    return (
        <section id="portfolio" className="section-padding bg-gray-50">
            <div className="container-max">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <h2 className="section-title">
                        Client <span className="gradient-text">Success Stories</span>
                    </h2>
                    <p className="section-subtitle">
                        Discover how my astrological guidance has transformed lives and brought positive changes to my clients.
                    </p>
                </div>

                {/* Filter Buttons */}
                <div className="flex flex-wrap justify-center gap-4 mb-12">
                    {filters.map((filter) => (
                        <button
                            key={filter}
                            onClick={() => setActiveFilter(filter)}
                            className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${activeFilter === filter
                                    ? 'bg-primary text-white shadow-lg'
                                    : 'bg-white text-gray-700 hover:bg-primary hover:text-white border border-gray-200'
                                }`}
                        >
                            {filter}
                        </button>
                    ))}
                </div>

                {/* Testimonials Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {filteredTestimonials.map((testimonial) => (
                        <div
                            key={testimonial.id}
                            className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                        >
                            {/* Header */}
                            <div className="flex items-center mb-4">
                                <div className="w-16 h-16 rounded-full overflow-hidden mr-4 border-2 border-primary/20">
                                    <img
                                        src={`/images/user/${testimonial.image}`}
                                        alt={testimonial.name}
                                        className="w-full h-full object-cover"
                                        onError={(e) => {
                                            e.target.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='64' height='64' viewBox='0 0 64 64'%3E%3Ccircle cx='32' cy='32' r='32' fill='%23f3f4f6'/%3E%3Ctext x='32' y='38' font-family='Arial, sans-serif' font-size='24' text-anchor='middle' fill='%236b7280'%3E${testimonial.name.charAt(0)}%3C/text%3E%3C/svg%3E`;
                                        }}
                                    />
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg">{testimonial.name}</h4>
                                    <p className="text-sm text-gray-600">{testimonial.service}</p>
                                    <div className="flex items-center mt-1">
                                        {[...Array(testimonial.rating)].map((_, i) => (
                                            <FaStar key={i} className="text-yellow-400 text-sm" />
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Quote */}
                            <div className="relative">
                                <FaQuoteLeft className="text-primary/20 text-2xl absolute -top-2 -left-1" />
                                <p className="text-gray-600 italic pl-6 leading-relaxed">
                                    "{testimonial.text}"
                                </p>
                            </div>

                            {/* Category Badge */}
                            <div className="mt-4">
                                <span className="inline-block bg-primary/10 text-primary px-3 py-1 rounded-full text-xs font-medium">
                                    {testimonial.category}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>

                {/* CTA Section */}
                <div className="text-center mt-16">
                    <div className="bg-white p-8 rounded-2xl shadow-lg max-w-2xl mx-auto">
                        <h3 className="text-2xl font-bold mb-4">Ready to Transform Your Life?</h3>
                        <p className="text-gray-600 mb-6">
                            Join hundreds of satisfied clients who have found clarity and direction through professional astrological guidance.
                        </p>
                        <button className="btn-primary">
                            <Link
                                to="contact"
                                smooth={true}
                                duration={500}
                                offset={-70}
                                className="btn-primary cursor-pointer text-center"
                            >
                                Book Your Reading Today
                            </Link>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Portfolio;
